import { type FC, type ChangeEvent, type ReactNode } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';

import { BasicSelect } from 'dibs-elements/exports/BasicSelect.tsx';

import fieldNames from '../../data/sellerApplicationFieldNames.json' with { type: 'json' };

type Props = {
    dataTn: string;
    onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
    errorMessage?: ReactNode;
    disabled?: boolean;
    value: string;
};

const messages = defineMessages({
    currency: {
        id: 'DealerApplicationForm.currency.placeholder',
        defaultMessage: 'Currency',
    },
});

const Currency: FC<Props> = ({ dataTn, onChange, errorMessage, disabled, value }) => {
    const intl = useIntl();

    return (
        <BasicSelect
            dataTn={dataTn}
            name={fieldNames.dealerInfo.averageItemPriceCurrency}
            hasAnimatedPlaceholder
            placeholder={intl.formatMessage(messages.currency)}
            options={[
                {
                    value: 'USD',
                    label: 'USD $',
                },
                {
                    value: 'GBP',
                    label: 'GBP £',
                },
                {
                    value: 'EUR',
                    label: 'EUR €',
                },
            ]}
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={disabled}
            value={value}
        />
    );
};

export default Currency;
